import { render, staticRenderFns } from "./OrdersAwaitingActions.vue?vue&type=template&id=48c2dcdb&"
import script from "./OrdersAwaitingActions.vue?vue&type=script&lang=js&"
export * from "./OrdersAwaitingActions.vue?vue&type=script&lang=js&"
import style0 from "./OrdersAwaitingActions.vue?vue&type=style&index=0&id=48c2dcdb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports